var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-cont',{staticClass:"modal-form",attrs:{"closeTo":_vm.closeTo}},[_c('modal-close',{nativeOn:{"click":function($event){_vm.$store.dispatch('GO_BACK', { $router: _vm.$router, fallback: _vm.closeTo })}}}),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f474254","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/ModalForm.vue
// module id = 407
// module chunks = 8